/**
 * Public Routes Configuration
 *
 * Defines all public routes that don't require authentication.
 */

import type { ReactElement } from 'react';

// Public Pages
import { LandingPage } from '../pages/public/LandingPage';
import { LoginPage } from '../pages/public/LoginPage';
import { RegisterPage } from '../pages/public/RegisterPage';
import { CertificateVerificationPage } from '../pages/public/CertificateVerificationPage';
import { ComponentDemoPage } from '../pages/public/ComponentDemoPage';
import { DevDashboardPage } from '../pages/public/DevDashboardPage';

/**
 * Route definition interface
 */
export interface RouteDefinition {
  path: string;
  element: ReactElement;
  label: string;
  showInNav?: boolean;
  children?: RouteDefinition[];
}

/**
 * Public routes configuration
 */
export const publicRoutes: RouteDefinition[] = [
  {
    path: '/',
    element: <LandingPage />,
    label: 'Home',
    showInNav: true,
  },
  {
    path: '/login',
    element: <LoginPage />,
    label: 'Login',
    showInNav: false,
  },
  {
    path: '/register',
    element: <RegisterPage />,
    label: 'Register',
    showInNav: false,
  },
  {
    path: '/verify',
    element: <CertificateVerificationPage />,
    label: 'Certificate Verification',
    showInNav: false,
  },
  {
    path: '/demo',
    element: <ComponentDemoPage />,
    label: 'Demo',
    showInNav: false,
  },
  {
    path: '/dev-dashboard',
    element: <DevDashboardPage />,
    label: 'Dev Dashboard',
    showInNav: false,
  },
];

/**
 * Get all public routes (flattened)
 */
export function getAllPublicRoutes(): RouteDefinition[] {
  const routes: RouteDefinition[] = [];

  function flattenRoutes(routeList: RouteDefinition[]) {
    routeList.forEach((route) => {
      routes.push(route);
      if (route.children) {
        flattenRoutes(route.children);
      }
    });
  }

  flattenRoutes(publicRoutes);
  return routes;
}

export default publicRoutes;